<template lang="html">
<div id="buildings">
    <el-row class="headLine">
        <!-- 新建 -->
        <el-col :span="4" style="text-align:left;">
            <el-dropdown size="small" type="primary" @command="clickDropdown">
                <el-button type="danger" size="small">
                    批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="del">删除</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-col>
        <!-- 选择器 -->
        <el-col :span="20" style="text-align:right;">
            <!-- <el-select v-model="value" placeholder="留言类型" size="small">
                <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select> -->
            <el-select v-model="status" placeholder="状态" clearable size="small" @change="statusChange">
                <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input v-model="searchText" placeholder="标题搜索" class="input" size="small">
                <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
        </el-col>
    </el-row>
    <List ref="list" />
</div>
</template>

<script>
import List from './src/list';
export default {
    components: {
        List
    },
    data() {
        return {
            searchText:'',
            status:'',
            options1: [{
                    value: 3,
                    label: '平台消息'
                },
                {
                    value: 1,
                    label: '团队消息'
                },
                {
                    value: 2,
                    label: '律师消息'
                },
            ],
            options2: [{
                    value: 1,
                    label: '未处理'
                },
                {
                    value: 2,
                    label: '已处理'
                },
            ],
        }
    },
    methods: {
        statusChange(e){
            var param={
                status:e,
            };
            this.$refs.list.search(param);
        },
        search(){
            var param={
                keyword:this.searchText,
            };
            this.$refs.list.search(param);
        },

        // 新建
        clickDropdown(e) {
            console.log(this.$refs.list.ids);
            if (this.$refs.list.ids.length > 0) {
                this.$refs.list.deleteDTO(this.$refs.list.ids);
            } else {
                this.$message.error('需要删除的消息不能为空!')
            }
        },
    },
    created() {

    }

}
</script>

<style lang="scss" scoped>
#buildings {
    font-size: 15px;
    background-color: #f5f5f5;
    min-height: 500px;

    .headLine {
        padding: 0 20px;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid #ebeef5;
        background-color: #fff;

        .headright {
            text-align: right;
            margin-right: 10px;
            display: block;

        }
    }

}

.input {
    width: 240px;
    border-radius: none;
}
</style>

<style lang="css">
#buildings .el-input__inner {
    border-radius: 0px !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?0a88f098